import {tns} from 'tiny-slider/src/tiny-slider';

const container = document.querySelector('.story__gallery')

if(container) {
  const slides = container.querySelectorAll('.stoty__gallery-item');

  if( slides && slides.length > 1) {
    tns({
      container: container,
      "autoWidth": true,
      "items": 2.4,
      "gutter": 20,
      "mouseDrag": true,
      "swipeAngle": false,
      "speed": 400
    });
  }
}
